/**
 * 統一されたナビゲーション処理
 */

import type { NavigationConfig } from '../types/navigation';

const NAVIGATION_OFFSETS: NavigationConfig = {
  experience: 150,
  skills: 100,
  about: 120,
  default: 120,
} as const;

/**
 * セクション名に基づいて適切なオフセットを取得
 */
export const getNavigationOffset = (sectionId: string): number => {
  return NAVIGATION_OFFSETS[sectionId as keyof NavigationConfig] ?? NAVIGATION_OFFSETS.default;
};

/**
 * 統一されたスクロール処理
 */
export const scrollToSection = (href: string): void => {
  const element = document.getElementById(href.substring(1));
  if (!element) return;

  const rect = element.getBoundingClientRect();
  const elementTop = rect.top + window.pageYOffset;
  const offset = getNavigationOffset(href.substring(1));
  const targetPosition = elementTop - offset;

  window.scrollTo({
    top: Math.max(0, targetPosition),
    behavior: 'smooth'
  });
};

/**
 * 統一されたナビゲーションハンドラー
 */
export const createNavigationHandler = (
  navigate: (path: string, options?: { replace?: boolean }) => void,
  location: { pathname: string },
  additionalCallback?: () => void
) => {
  return (href: string): void => {
    // 追加のコールバック実行（モバイルメニューを閉じるなど）
    additionalCallback?.();

    // ページルート処理
    if (href.startsWith('/')) {
      navigate(href);
      return;
    }

    // ハッシュリンク処理
    if (href.startsWith('#')) {
      if (location.pathname === '/') {
        // 同一ページ内でのスクロール
        scrollToSection(href);
      } else {
        // 別ページからの遷移
        navigate(`/${href}`, { replace: false });
      }
    }
  };
};